(ns frontend.test.upload
  (:require [frontend.routing :as routing]
            [frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.upload-modal :as upload-modal]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]))

(def uploads-path [::uploads])

(defn mount
  []
  (rf/reg-sub
    ::uploads
    (fn [db]
      (get-in db uploads-path)))
  (rf/reg-event-fx
    ::hide!
    (fn [{db :db} _]
      ))
  (rf/reg-event-fx
    ::set-files
    (fn [{db :db} [_ files]]
      {:db (assoc-in db uploads-path files)})))

(def file-uploading {:name       "PE_company_dataexcel_buyout_X_Yrkesakademin AB.xlsx"
                     :status     :uploading
                     :size       3204
                     :percentage 72})

(def file-error {:name       "PE_fund_dataexcel_Buyout_X Error.xlsx"
                 :size       0
                 :status     :error
                 :percentage 100
                 :message    "Template error: id=[Sheet 'Current portfolio (EUR)' not found]"})

(def file-error2 {:name "Company report - Koiviston Auto.xlsx"
                  :size 20342
                  :status :error
                  :percentage 100
                  :message "Name does not match any holdings : Yrkesakademin AB, Malte Månson AB, Forenom Group Oy, Renoa Group Oy"})

(def file-processing {:name       "test file.xlsx"
                      :size       4000123
                      :status     :processing
                      :percentage 100})

(def file-ok {:name       "OK file.xlsx"
              :size       23742
              :status     :complete
              :percentage 100})

(defn modal-view
  []
  (mount)
  (fn []
    (let [uploads @(rf/subscribe uploads-path)]
      [:div
       {:class-name "mt-4 px-4"}
       [:div
        (if-not (seq uploads)
          [:div
           [button/primary-solid
            {:on-click #(rf/dispatch [::set-files [file-uploading]])}
            "Uploading"]
           [button/primary-solid
            {:on-click #(rf/dispatch [::set-files [file-processing]])}
            "Processing"]
           [button/danger-solid
            {:on-click #(rf/dispatch [::set-files [file-error]])}
            "Error"]
           [button/danger-solid
            {:on-click #(rf/dispatch [::set-files [file-error2]])}
            "Error2"]
           [button/primary-solid
            {:on-click #(rf/dispatch [::set-files [file-ok]])}
            "Complete"]
           [button/secondary-hollow
            {:on-click #(rf/dispatch [::set-files [file-uploading
                                                   file-error
                                                   file-error2
                                                   file-processing
                                                   file-ok]])}
            "All"]]

          [upload-modal/view [::uploads] [::hide!]])]])))

(defmethod routing/render-view :test/upload [{:keys [route-params]}]
  [modal-view])
